"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
const BlankButton_1 = require("./BlankButton");
function IconButtonComp({ Icon, onClick, disabled }, ref) {
    return ((0, jsx_runtime_1.jsx)(BlankButton_1.BlankButton, Object.assign({ className: (0, classnames_1.default)('w-11', 'h-11', 'flex', 'items-center', 'justify-center', {
            'bg-white text-silver-90 hover:bg-silver-5 hover:text-silver-100 hover:shadow-sm border-white': !disabled,
            'bg-silver-10 text-silver-50': disabled,
        }), onClick: onClick, ref: ref, disabled: disabled }, { children: (0, jsx_runtime_1.jsx)(Icon, { size: 20 }) })));
}
exports.IconButton = (0, react_1.forwardRef)(IconButtonComp);
//# sourceMappingURL=IconButton.js.map